import React from 'react';
import PropTypes from 'prop-types';
import styles from './HpRespCollectionsModuleItem.scss';

function HpRespCollectionsModuleItem({ item, onClick }) {
    const { title, imageUrl, link } = item;

    return (
        <a className={styles.link} href={link} onClick={onClick} data-tn="collections-item-link">
            <div className={styles.imageWrapper}>
                <img
                    className={styles.image}
                    src={imageUrl}
                    alt={title}
                    data-tn="collections-item-image"
                />
            </div>
            <span className={styles.title} data-tn="collections-item-title">
                {title}
            </span>
        </a>
    );
}

HpRespCollectionsModuleItem.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string,
        imageUrl: PropTypes.string,
        link: PropTypes.string,
    }).isRequired,
    onClick: PropTypes.func,
};

HpRespCollectionsModuleItem.defaultProps = {
    onClick: () => {},
};

export { HpRespCollectionsModuleItem };
